<template>
    <div class="popup" ref="popup">

        <!--        <transition name="fade">-->
        <div class="filter-overlay"
             @touchmove.prevent.stop
             @click.stop.prevent="$emit('input', false)"
             @touchstart.stop.prevent="$emit('input', false)"
             v-show="value"></div>
        <!--        </transition>-->

        <!--        <transition :name="`popupr-${type}`">-->
        <!--type : top bottom-->
        <div :class="`popupr-${type}`"

             v-if="value">
            <slot></slot>
        </div>
        <!--        </transition>-->


    </div>
</template>
<script>
    import {ClearBodyOverHidden, SetBodyOverHidden} from "../../../assets/js/utils";

    export default {
        props: [
            'value',
            'type',
            'unoverflow',
        ],
        watch: {
            value(newVal) {
                if (this.unoverflow) {
                    return
                }
                if (newVal) {
                    SetBodyOverHidden();
                    // document.body.append(this.$refs.popup);
                } else {
                    ClearBodyOverHidden()
                }
            }
        }
    }
</script>